import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function UserIcon({ className, width = 33, height = 33 }: IconProps) {
    return (
        <>
            <svg
                className={cn(className)}
                width={width}
                height={height}
                viewBox='0 0 33 32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M16.7128 15.4933C16.6728 15.4933 16.6461 15.4933 16.6061 15.4933C16.5395 15.48 16.4461 15.48 16.3661 15.4933C12.4995 15.3733 9.57947 12.3333 9.57947 8.58667C9.57947 4.77333 12.6861 1.66667 16.4995 1.66667C20.3128 1.66667 23.4195 4.77333 23.4195 8.58667C23.4061 12.3333 20.4728 15.3733 16.7528 15.4933C16.7395 15.4933 16.7261 15.4933 16.7128 15.4933ZM16.4995 3.66667C13.7928 3.66667 11.5795 5.88 11.5795 8.58667C11.5795 11.2533 13.6595 13.4 16.3128 13.4933C16.3795 13.48 16.5661 13.48 16.7395 13.4933C19.3528 13.3733 21.4061 11.2267 21.4195 8.58667C21.4195 5.88 19.2061 3.66667 16.4995 3.66667Z'
                    fill='currentColor'
                />
                <path
                    d='M16.7261 30.0667C14.1128 30.0667 11.4861 29.4 9.49948 28.0667C7.64615 26.84 6.63281 25.16 6.63281 23.3333C6.63281 21.5067 7.64615 19.8133 9.49948 18.5733C13.4995 15.92 19.9795 15.92 23.9528 18.5733C25.7928 19.8 26.8195 21.48 26.8195 23.3067C26.8195 25.1333 25.8061 26.8267 23.9528 28.0667C21.9528 29.4 19.3395 30.0667 16.7261 30.0667ZM10.6061 20.2533C9.32615 21.1067 8.63281 22.2 8.63281 23.3467C8.63281 24.48 9.33948 25.5733 10.6061 26.4133C13.9261 28.64 19.5261 28.64 22.8461 26.4133C24.1261 25.56 24.8195 24.4667 24.8195 23.32C24.8195 22.1867 24.1128 21.0933 22.8461 20.2533C19.5261 18.04 13.9261 18.04 10.6061 20.2533Z'
                    fill='currentColor'
                />
            </svg>
        </>
    );
}

export default UserIcon;

